import { useParams } from "react-router-dom";
import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsSkillDetailPage() {
  const params = useParams<{ id: string }>();

  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="skills-detail"
      settingsSkillId={params.id}
    />
  );
}
